import { useUser } from '../hooks/useAppState'
import PersonalPhotoView from './PersonalPhotoView'

// override url is used in SettingsPersonalPhotoModal
export function SettingsPersonalPhotoContainer({ url: overrideUrl }: { url?: string }) {
  const user = useUser()

  return <PersonalPhotoView user={user} overrideUrl={overrideUrl} />
}
